import React, { useEffect, useState,SyntheticEvent, ReactElement } from 'react'
import  "../ScheduleTodosPage/ScheduleTodosPage.css"
import DynamicSVG from '../DynamicSVG/DynamicSVG'
import useModal from '../../hooks/useModal'
import Modal from '../Modal/Modal'
import ScheduleHandler from '../../Database/handlers/ScheduleHandler'
import ConvertToSchedule from '../../Utilities/ConvertToSchedule'
import { ITodo, ITodoSchedule, schedule, TodoObj } from '../../types/interfaces'
import ScheduleCalender from './ScheduleCalendar/ScheduleCalendar'
import TodosSchedule from './TodosSchedule/TodosSchedule'
import Drawer from '../Drawer/Drawer'
import useDrawer from '../../hooks/useDrawer'
import useLocalStorage from '../../hooks/useLocalStorage'
import TopNavBar from '../TopNavBar/TopNavBar'
import TodoHandler from '../../Database/handlers/TodoHandler'


export default function ScheduleTodosPage() {
  const [isCreateDrawerOpen, toggleCreateDrawer] = useDrawer()
  const [isEditDrawerOpen,toggleEditDrawer] = useDrawer()
  const [TodosForm, setTodosForm] = useState<{
    todo_title: string,todo_description: string,todo_priority: "Low"|"Medium"|"High"|string}>({
    todo_title:"",todo_description:"",todo_priority:"Low"
  })
  const [project,setProject] = useLocalStorage("project",null)
  const [state, setstate] = useState<{currentSchedule:ITodoSchedule, tempTodosArr: ITodo[], Schedules: ITodoSchedule[] }>({
    tempTodosArr: [],
    Schedules: [],
    currentSchedule: {
      title:"",description:"",scheduleDate:new Date(),todosArr:[],project:project.ProjectName
    }
  })
  const schedulehandler = new ScheduleHandler()
  const todohandler = new TodoHandler()
  function handleDeleteSchedule(scheduleKey:number) {
    schedulehandler.DeleteSchedule(scheduleKey).then(() => {
      schedulehandler.FetchSchedules(project.ProjectName).then((schedules) => {
        // const elementsArr = ConvertToSchedule(schedules,handleDeleteSchedule,toggleEditDrawer)
        setstate({...state, Schedules: schedules, tempTodosArr: [] })
      })
   
    })
  }
  function handleEditSchedule(scheduleData:ITodoSchedule) {
    schedulehandler.FetchSchedules(project.ProjectName).then((schedules:ITodoSchedule[]) => {
      toggleEditDrawer()
      setstate({...state,
        currentSchedule: scheduleData,
        tempTodosArr: scheduleData.todosArr,
      })
      console.log(state)
    })
  }
  function handleEditScheduleSubmit(event:React.SyntheticEvent) {
    event.preventDefault()
    if (state.tempTodosArr.length <= 0) return 
    const form = event.target as HTMLFormElement
    const target = event.target as typeof event.target & {
      title: { value: string };
      description: { value: string };
      scheduleDateTime: { value: string };
    }
    console.log(state)
    const formObj= {
      id:state.currentSchedule?.id? state.currentSchedule?.id:0,
      title: target.title.value,
      description: target.description.value,
      todosArr: state.tempTodosArr,
      scheduleDate:target.scheduleDateTime.value,
      project:project.ProjectName
    }
    
    console.log(formObj)
    schedulehandler.EditSchedule(formObj?.id, formObj).then(() => {
      setstate({
      ...state,Schedules:state.Schedules,tempTodosArr:[]
    })
    form.reset()
    toggleEditDrawer()
    })
    
  }
  function GetFormattedDate(targetdate: Date|string) {
    //  Below for datetime-local other formats
    // const formattedDate = new Date(date)
    //   .toISOString() // Converts to format
    //   .split(".") // will split timezone and date
    //   .slice(0, 1) // remove the last element which is timezone
    //   .join("").split(":") // join again and split by colon for time
    //   .splice(0, 2) // last element is seconds , removes that
    //   .join(":") // join again , giving format YYYY-MM-DD T hh-mm

    // Below for date only formats
    let date = new Date(targetdate.toString())
    const dateMonth =date.getMonth()+1 < 10 ? `0${date.getMonth()+1}`:`${date.getMonth()+1}`
    const dateYear =date.getFullYear() < 10 ? `0${date.getFullYear()}`:`${date.getFullYear()}`
    const formattedDate = `${dateYear}-${dateMonth}-${date.getDate()}`
    return formattedDate
  }
  
  function handleScheduleSubmit(event:React.SyntheticEvent) {
    event.preventDefault()
    if (state.tempTodosArr.length <= 0) return 
    const form = event.target as HTMLFormElement
    const target = event.target as typeof event.target & {
      title: { value: string };
      description: { value: string };
      scheduleDateTime: { value: string };
    }
    const formObj = {
      title: target.title.value,
      description: target.description.value,
      todosArray: state.tempTodosArr,
      scheduleDate: new Date(target.scheduleDateTime.value),
      project:project.ProjectName
    }

    console.log(formObj)
    schedulehandler.CreateSchedule(
      formObj.title,formObj.description,formObj.todosArray,
      formObj.scheduleDate,formObj.project)
    setstate({
      ...state,Schedules:state.Schedules,tempTodosArr:[]
    })
    form.reset()
    toggleCreateDrawer()
  }
  function handleTodoSubmit(event:SyntheticEvent) {
    // event.preventDefault()
    if (TodosForm.todo_title == "" || TodosForm.todo_description == "") return
    
    console.log(TodosForm)
    todohandler.DB.todos.where({ status: "Pending" }).toArray().then((todos) => {
      const formObj:ITodo = {
      // id:state.tempTodosArr.length+1,
      title:TodosForm.todo_title,
      description: TodosForm.todo_description,
      priority: TodosForm.todo_priority,
      status:"Pending",project:project.ProjectName
    }
    setstate({...state, tempTodosArr: [...state.tempTodosArr, formObj] })
    setTodosForm({
      todo_title:"",todo_description:"",todo_priority:"Low"
    })
    })
    
    // childtoggleModal()
  }
  function handleTodosFormchange(event:React.ChangeEvent<HTMLSelectElement|HTMLInputElement|HTMLTextAreaElement>) {
    // [event.currentTarget.name]:event.currentTarget.value
    setTodosForm({
      todo_title: event.target.name == "todo_title" ? event.target.value : TodosForm.todo_title,
      todo_description: event.target.name == "todo_description" ? event.target.value : TodosForm.todo_description,
      todo_priority:event.target.name == "todo_priority" ? event.target.value :TodosForm.todo_priority
    })
    console.log(event.target.value)
  }
  function RemoveScheduleTodo(event:React.MouseEvent<HTMLButtonElement>) {
    console.log(parseInt(event.currentTarget.id))
    let todosArr = state.tempTodosArr.slice().filter((todo) => {
      return todo.title?.toString() != event.currentTarget.id
    })
    setstate({...state,tempTodosArr:todosArr,Schedules:state.Schedules})
  }
  useEffect(() => {
    schedulehandler.FetchSchedules(project.ProjectName).then((schedules) => {
      setstate({...state,Schedules:schedules})
    })
  }, [isCreateDrawerOpen,isEditDrawerOpen])
  
  
  return (
    <>
      <Drawer isOpen={isCreateDrawerOpen} toggleDrawer={toggleCreateDrawer}>
        <>
          <h3 className='Drawer-Title'>Create a brand new schedule :</h3>
          <form id='Todo-Form' onSubmit={handleScheduleSubmit}>
            <div className='Input-Container'>
              <label htmlFor='Title-Input'>Schedule Title :</label>
              <input name='title' id='Title-Input' required />
            </div>
            <br />
            <div className='Input-Container'>
              <label htmlFor='Description-Input'>Schedule Description :</label>
              <textarea name='description' id='Description-Input' required />
            </div>
            <div className='Input-Container'>
              <label htmlFor='ScheduleTime'>Schedule Date :</label>
              <input name='scheduleDateTime' min={GetFormattedDate(new Date())} type="date" id='ScheduleTime' required />
            </div>
            
            {/* <label htmlFor='Add-Todos'>Add Todos :</label>
            <button type='button' onClick={childtoggleModal}>Add a Todo</button>
            <span><DynamicSVG SvgName="Alert-Icon"/>Add at least 1 todo</span> */}
            
          <h3 className='Drawer-Title'>Add Todos :</h3>
          <div className='Input-Container'>
            <label htmlFor='Title-Input-Todo'>Title :</label>
            <input value={TodosForm.todo_title} onChange={handleTodosFormchange} name='todo_title' id='Title-Input-Todo'/>
          </div>
          <br />
          <div className='Input-Container'>
            <label htmlFor='Description-Input-Todo'>Description :</label>
            <textarea value={TodosForm.todo_description} onChange={handleTodosFormchange} name='todo_description' id='Description-Input-Todo'/>
          </div>
          <div className='Input-Container'>
            <label htmlFor='Todo-priorities'>Priority :</label>
            <select value={TodosForm.todo_priority}  onChange={handleTodosFormchange} name='todo_priority' id='Todo-priorities'>
              <option value="Low">Low</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
            </select>
          </div>
            
            <br />
            
            <button type="button" onClick={handleTodoSubmit} className='Drawer-Submit'>
              Add Todo
            </button>
            <ul className='Todos-Container'>
              {state.tempTodosArr?.map((element:ITodo,i:number) => {
                return (
                  <li key={`${element?.id}`} >
                    <p>{element?.title.slice(0,20)}</p>
                    <span className={'Priority-Symbol ' + element?.priority}>
                      {element?.priority}
                    </span>
                    <button type='button' id={`${element?.title}`} onClick={RemoveScheduleTodo}>X</button>
                  </li>
                )
              })}
            </ul>
            <button type='submit' className='Drawer-Submit'>
              Submit
            </button>

          </form>
        </>
      </Drawer>
      <Drawer isOpen={isEditDrawerOpen} toggleDrawer={toggleEditDrawer}>
        <>
          <h3 className='Drawer-Title'>Edit schedule :</h3>
          <form id='Todo-Form' onSubmit={handleEditScheduleSubmit}>
            <div className='Input-Container'>
              <label htmlFor='Title-Input'>Schedule Title :</label>
              <input defaultValue={state.currentSchedule.title} name='title' id='Title-Input' required />
            </div>
            <br />
            <div className='Input-Container'>
              <label htmlFor='Description-Input'>Schedule Description :</label>
              <textarea defaultValue={state.currentSchedule.description} name='description' id='Description-Input' required />
            </div>
            <div className='Input-Container'>
              <label htmlFor='ScheduleTime'>Schedule Date :</label>
              <input defaultValue={GetFormattedDate(state.currentSchedule.scheduleDate)} name='scheduleDateTime' min={GetFormattedDate(new Date())} type="date" id='ScheduleTime' required />
            </div>
            <br/>
            <br/>
            {/* <label htmlFor='Add-Todos'>Add Todos :</label>
            <button type='button' onClick={childtoggleModal}>Add a Todo</button>
            <span><DynamicSVG SvgName="Alert-Icon"/>Add at least 1 todo</span> */}
            
          <h3 className='Drawer-Title'>Edit Todos :</h3>
          <div className='Input-Container'>
            <label htmlFor='Title-Input-Todos'>Title :</label>
            <input value={TodosForm.todo_title} onChange={handleTodosFormchange} name='todo_title' id='Title-Input-Todos'/>
          </div>
          <br />
          <div className='Input-Container'>
            <label htmlFor='Description-Input-Todos'>Description :</label>
            <textarea value={TodosForm.todo_description} onChange={handleTodosFormchange} name='todo_description' id='Description-Input-Todos'/>
          </div>
          <div className='Input-Container'>
            <label htmlFor='Todo-priorities'>Priority :</label>
            <select value={TodosForm.todo_priority}  onChange={handleTodosFormchange} name='todo_priority' id='Todo-priorities'>
              <option value="Low">Low</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
            </select>
          </div>
          <br />
            
            <button type="button" onClick={handleTodoSubmit} className='Drawer-Submit'>
              Add Todo
            </button>
            <ul className='Todos-Container'>
              {state.tempTodosArr?.map((element:ITodo,i:number) => {
                return (
                  <li key={`${element?.id}`} >
                    <p>{element?.title.slice(0,20)}</p>
                    <span className={'Priority-Symbol ' + element?.priority}>
                      {element?.priority}
                    </span>
                    <button type='button' id={`${element?.title}`} onClick={RemoveScheduleTodo}>X</button>
                  </li>
                )
              })}
            </ul>
            <button type='submit' className='Drawer-Submit'>
              Submit
            </button>

          </form>
        </>
      </Drawer>
      
      <div className='Side-Content Schedule-Todos-Container'>
        {/* <div className="Schedule-Todos Topbar">
          
        </div> */}
        <TopNavBar OptionsMenuElements={[
          <button id='Create-Todo-Btn' onClick={toggleCreateDrawer}>
            <DynamicSVG SvgName="Plus-Icon" />
            Create a schedule
          </button>
        ]}>
          <>
            <h2 className='Topbar-title TopNav-Content'>{project.ProjectName}</h2>
          </>
          
          
          
        </TopNavBar>
          {/* {state.SchedulesElements} */}
          <ScheduleCalender schedules={state.Schedules}/>
        <div className='CalendarEvents'>
        {
          state.Schedules?.map((schedule) => {
            return <TodosSchedule
              title={schedule.title}
              description={schedule.description}
              todosArr={schedule.todosArr}
              scheduleDateTime={schedule.scheduleDate.toString()}
              scheduleKey={schedule.id? schedule.id?.toString():""}
              deleteCallback={handleDeleteSchedule} editCallback={handleEditSchedule} />
          })
      }
      </div>
      </div>
    </>
    
  )
}
